export default __webpack_public_path__ + "static/media/nobanar.20b38727.jpg";